import React, { Component } from 'react';

export default class NotAuthorized extends Component {
    render(){
        return(
        <div className="NotAuthorized">
            <h1>HTTP Error 401: Unauthorized Access</h1>
            <p>You have attempted to access a page for which you are not authorized.</p>
        </div>
        )
    }
}